export default __webpack_public_path__ + "static/p3_en-3f01b1350db25f2ca8018d893354ef25.png";